import { Layout } from "antd";
const { Content } = Layout;

export default function ContentFrame(props: any) {
  return (
    <Layout>
      <Content>{props.children}</Content>
    </Layout>
  );
}
